import styled, { css } from "styled-components"
import { darken, mix } from "polished"

export const Container = styled.div`
  ${({ invalid, theme }) =>
    !!invalid &&
    css`
      border-radius: 1rem;
      padding: 0.75rem 1.25rem;
      border: 2px solid ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
      background-color: ${mix(0.8, "#fff", theme.colors.danger)};
    `}

  ${({ invalid, simpleForm, theme }) =>
    !!invalid &&
    !simpleForm &&
    css`
      border: 2px solid ${theme.colors.danger};
      background-color: ${mix(0.95, "#fff", theme.colors.danger)};

      & > :not(:last-child) {
        margin-bottom: 0.5rem;
      }
    `}

    ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      margin: 2px 0 8px;
      padding-right: 4px;
    `}
`

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.body};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  cursor: pointer;
  margin: 0;
  line-height: 0;

  ${({ textColor }) =>
    textColor &&
    css`
      color: ${textColor} !important;
    `}

  ${({ invalid, theme }) =>
    !!invalid &&
    css`
      color: ${darken(theme.colors.fields.invalid.darkenAmount, theme.colors.danger)};
    `}

  ${({ simpleForm, theme }) =>
    !!simpleForm &&
    css`
      color: ${theme.colors.fields.text};
      left: 18px;
      font-size: 16px;
      font-weight: 400;
      position: relative;
      top: -2px;
    `}
`

export const RadioContainer = styled.label`
  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      display: block;
      position: relative;
      padding-left: 24px;
      margin: 3px 0;
      cursor: pointer;
      font-size: 22px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      &:not(:last-child) {
        margin-bottom: 16px;
      }

      & > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      &:hover input + span {
        border-color: ${({ theme }) => theme.colors.primary};
      }

      & > input:checked + span {
        border-color: ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.colors.primary};
      }

      & > input:checked + span:after {
        display: block;
      }

      & > span:after {
        top: 6px;
        left: 6px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: white;
      }
    `}

  ${({ simpleForm }) =>
    !simpleForm &&
    css`
      margin-right: 20px;
      margin-bottom: 0.5rem;
      display: block;
    `}
`

export const RadioButton = styled.input`
  cursor: pointer;
  margin: 0;
  margin-right: 0.6rem;
  width: 15px;
  height: 15px;
  position: relative;
  top: 2px;
`

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 24px;
  width: 24px;
  background-color: transparent;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.fields.border};

  &:after {
    content: "";
    position: absolute;
    display: none;
  }
`
